import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../../@core/service/api.service';
import { CompilationDataModel } from '../../../../@models/erp/compilationData';

@Component({
  selector: 'ngx-doc-store-dropdown',
  templateUrl: './doc-store-dropdown.component.html',
  styleUrls: ['./doc-store-dropdown.component.scss'],
})
export class DocStoreDropdownComponent implements OnInit {
  @Input() store: string;
  @Input() value: string;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>()

  data: CompilationDataModel;
  storeOptions: { id: string, name: string }[]

  constructor(private api: ApiService) { }

  async ngOnInit() {
    this.data = await this.api.getCompilationData();
    this.storeOptions = this.data[this.store].map(m => ({ id: m, name: m }));
  }


  selectChanged(value: string) {
    this.valueChange.emit(value)
  }

  async addStoreValue() {
    const cd = await this.api.saveCompilationData(this.store, this.value, true);
    this.storeOptions = cd && cd[this.store] && cd[this.store].map(m => ({ id: m, name:m }))
  }

  async removeStoreValue() {
    const cd = await this.api.saveCompilationData(this.store, this.value, false);
    this.storeOptions = cd && cd[this.store] && cd[this.store].map(m => ({ id: m, name:m }))
  }

}
